module.exports = __webpack_public_path__ + "static/images/right-arrow.2dJuaFn.svg";